import React from "react";
import PropTypes from "prop-types";
import TablePagination from "@material-ui/core/TablePagination";
import { ContainPagination } from "./PaginationComponent.styled";

const PaginationComponent = ({
  rowsPerPage,
  totalItems,
  page,
  rowsPerPageOptions,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {

  return (
    <ContainPagination>
      <TablePagination
        component="div"
        count={totalItems}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
        }}
      />
    </ContainPagination>
  );
};

PaginationComponent.propTypes = {
  rowsPerPage: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  totalItems: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
};

export default PaginationComponent;
